/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import headerBg from './Assets/banner_bg.png';
import hand1 from './Assets/hand1';
import hand2 from './Assets/hand2';
import hand3 from './Assets/hand3';
import Link from 'react-router-dom/Link';
import welcomeImg from './Assets/welcome-img.png';
import './Home.scss';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.className = '';
    const root = document.getElementById('root');
    root.classList.add('home');
    return () => {
      root.classList.remove('home');
    }
  }, []);

  return (
    <div className='page home'>
      <img className='header-bg' src={headerBg} alt='Imagen de fondo'></img>
      <div className='container'>
        <section className='welcome-wrapper'>
          <div className='welcome-wrapper__left'>
            <h1 className='title'>
              La nueva forma de mostrar el menú de tu bar
            </h1>
            <p>
              ¡Destacate del resto y elegí la manera más <span>sencilla</span> y <span>eficiente</span> de llegar a tus comensales!
            </p>
            <a className='button' href='#how-it-works'>Como funciona</a>
          </div>
          <div className='welcome-wrapper__right'>
            <img className='welcome-bg' src={welcomeImg} alt='Imagen de fondo' />
          </div>
        </section>
        <section id='how-it-works' className='steps-wrapper'>
          <h2>
            Como funciona
          </h2>
          <div className='steps-wrapper__items'>
            <div className='steps-wrapper__items__item'>
              <img src={hand1} alt='Paso 1'></img>
              <h3>Llega un cliente</h3>
              <p>Escanea un código QR presente en cada mesa y accede desde su celular a todos tus platos</p>
            </div>
            <div className='steps-wrapper__items__item'>
              <img src={hand2} alt='Paso 2'></img>
              <h3>Decide qué comer</h3>
              <p>Elige el plato que más le gusta entre todas las opciones disponibles y se lo informa a algún mozo</p>
            </div>
            <div className='steps-wrapper__items__item'>
              <img src={hand3} alt='Paso 3'></img>
              <h3>¡Listo!</h3>
              <p>Ya está todo preparado para que comience a cocinarse el pedido</p>
            </div>
          </div>
        </section>
        <section className='focus-wrapper'>
          <h2>
            Comenzá a enfocarte en lo <br />
            que realmente importa
          </h2>
          <div className='focus-wrapper__items'>
            <div className='focus-wrapper__items__item'>
              <i className='customers' />
              <h3>Tus clientes</h3>
              <p>Ahora van a poder tener todo tu menú a tan solo un click de distancia</p>
            </div>
            <div className='focus-wrapper__items__item'>
              <i className='business' />
              <h3>Tu negocio</h3>
              <p>Actualizar tus platos y precios nunca fue tan fácil</p>
            </div>
            <div className='focus-wrapper__items__item'>
              <i className='earth' />
              <h3>Nuestro planeta</h3>
              <p>Comenzá a disminuir la cantidad de papel impreso en tus menúes</p>
            </div>
          </div>
        </section>
      </div>
      <section className='faqs-wrapper'>
        <div className='faqs-wrapper__limiter'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#6754e2 !important" fillOpacity="10" d="M0,64L80,85.3C160,107,320,149,480,138.7C640,128,800,64,960,58.7C1120,53,1280,107,1360,133.3L1440,160L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
          </svg>
        </div>
        <div className='faqs-wrapper__content'>
          <div className='faqs-wrapper__content__items container'>
            <h2>Preguntas frecuentes</h2>
            <details>
              <summary role="button" className='no-border' aria-expanded="false"><strong>¿Qué es Tu Menú Online?</strong></summary>
              <p>
                <span>Somos una plataforma desarrollada para optimizar y mejorar la experiencia de tus clientes a la hora de realizar un pedido en tu bar.</span>
                Buscamos reducir la cantidad necesaria de menúes impresos para llegar a cada uno de tus comensales, brindándoles la posibilidad de acceder a todos tus platos con tan solo escanear un código QR presente en cada mesa.</p>
            </details>
            <details>
              <summary role="button" aria-expanded="false"><strong>¿Es necesario descargar una aplicación?</strong></summary>
              <p>
                No, no es necesario. La mayoría de los celulares cuentan hoy en día con un lector QR en sus cámaras fotográficas. En caso de no contar con uno, podés acceder al menú desde cualquier navegador.
              </p>
            </details>
            <details>
              <summary role="button" aria-expanded="false"><strong>¿Puedo realizar un pedido desde la plataforma? ¿Tiene algún costo?</strong></summary>
              <p>
                La plataforma no permite realizar pedidos. Acceder a la misma no tiene ningún tipo de costo.
              </p>
            </details>
            <details>
              <summary role="button" aria-expanded="false"><strong>¿Debo registrarme para poder ver el menú?</strong></summary>
              <p>
                Queremos facilitar las cosas, no complicarlas. Lo único que necesitás para acceder es un dispositivo móvil y conexión a internet.
              </p>
            </details>
            <details>
              <summary role="button" aria-expanded="false"><strong>¿Es segura la plataforma?</strong></summary>
              <p>
                <span>Absolutamente. Es tan simple y seguro como navegar en un sitio web.</span>
                La plataforma cuenta además con certificado de seguridad y en ningún momento solicitaremos datos sensibles o confidenciales.
              </p>
            </details>
            <details>
              <summary role="button" aria-expanded="false"><strong>¿Qué debo hacer para formar parte de Tu Menu Online?</strong></summary>
              <p>
                <span>Escribinos. En la esquina inferior derecha vas a encontrar una ventana de chat para contactarnos.</span>
                Si hay alguien en línea responderá tus dudas a la brevedad, de lo contrario, dejanos tu pregunta y un mail para que podamos responderte.
              </p>
            </details>
          </div>
        </div>
      </section>
      <section className='container'>
        <Link className='button' to='/oyashima'>Ver un menú</Link>
      </section>
    </div>
  );
};

export default Home;